import { type FC } from 'react'
import { FormattedMessage } from 'react-intl'

import { ErxHubAdviceCard } from './ErxHubAdviceCard'
import { ErxHubPrescriptionCard } from './ErxHubPrescriptionCard'
import { ErxHubServicesCard } from './ErxHubServicesCard'

export const ErxHub: FC = () => {
  return (
    <div
      className="container py-10"
      itemScope
      itemType="https://schema.org/FAQPage"
    >
      <h2 className="px-10 text-center text-xl font-medium tablet:text-center desktop:text-2xl">
        <FormattedMessage id="nfc.moreInfo.title" />
      </h2>

      <div className="mt-4 flex w-full flex-col items-stretch gap-4 tablet:flex-row">
        <ErxHubPrescriptionCard />
        <ErxHubServicesCard />
        <ErxHubAdviceCard />
      </div>
    </div>
  )
}
